import { Component, Input, OnInit } from "@angular/core";
import { UtilsService } from "app/auth/service/utils.service";
import { SALES_COSTS } from "../../analytics/analytics.config";
import { UserService } from "app/auth/service";
import moment from "moment";

@Component({
  selector: "app-user-economic-graph",
  templateUrl: "./user-economic-graph.component.html"
})
export class UserEconomicGraphComponent implements OnInit {
  @Input() userHash: string = null;
  @Input() availableYears: number[] = null;
  public dataChart: any = null;
  public filterYear: number = moment().year();
  dataChartColumns: any;
  chartOptions: any = SALES_COSTS;

  constructor(public _utilService: UtilsService, private _userService: UserService) {
  }

  async ngOnInit() {
    await this.loadEconomic();
  }

  async loadEconomic(): Promise<void> {
    await this._userService.getUserEconomicGraph(this.userHash, this.filterYear).then(async (resp: any) => {
      this.dataChartColumns = resp;
      await this.initChart();
    });
  }

  async initChart() {
    const monthNames = moment.months().map((month) => month[0].toUpperCase() + month.substr(1).toLowerCase());

    const monthlyTotals = {};
    monthNames.forEach((month) => {
      monthlyTotals[month] = {
        real_cost: 0,
        real_profit: 0,
        margin_currency: 0
      };
    });

    this.dataChartColumns.forEach((item) => {
      const real_cost = Number(item.total_real_cost || 0);
      const real_profit = Number(item.total_real_profit || 0);
      const margin_currency = real_profit > 0 ? real_profit - real_cost : 0;
      const month = monthNames[item.month - 1];
      monthlyTotals[month].real_cost += real_cost;
      monthlyTotals[month].real_profit += real_profit;
      monthlyTotals[month].margin_currency += margin_currency;
    });

    const realCostData = Object.values(monthlyTotals).map((total: any) => total.real_cost)
    const realProfitData = Object.values(monthlyTotals).map((total: any) => total.real_profit);
    const realMarginCurrency = Object.values(monthlyTotals).map((total: any) => total.margin_currency);

    this.dataChart = {
      series: [
        { name: await this.translate("EFFECTIVE_COST"), type: "column", data: realCostData },
        { name: await this.translate("EFFECTIVE_REVENUE"), type: "column", data: realProfitData },
        { name: await this.translate("EURO_MARGIN"), type: "column", data: realMarginCurrency }
      ],
      xaxis: { categories: monthNames }
    };
  }

  translate(label: string) {
    return this._utilService.translate(label);
  }

  getSum(array: number[]){
    return array.reduce((accumulatore, numero) => accumulatore + numero, 0);
  }
}
